import { render, staticRenderFns } from "./TitleTextBase.vue?vue&type=template&id=ef76179e&scoped=true&lang=pug&"
var script = {}
import style0 from "./TitleTextBase.vue?vue&type=style&index=0&id=ef76179e&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef76179e",
  null
  
)

export default component.exports